import { useEffect, useState } from "react";
import { MaintenanceAPI } from "../api";
import './home.css';

export default function AdminMaintenance() {
  const [loading, setLoading] = useState(true);
  const [saving, setSaving] = useState(false);
  const [error, setError] = useState("");
  const [msg, setMsg] = useState("");
  const [form, setForm] = useState({
    enabled: false,
    message: "",
    allowLogin: true,
    allowImpressumPublic: true,
    extendedMode: false,
    extendedContent: [
      { title: "Was passiert gerade?", body: "Wir führen Wartungsarbeiten durch, damit AP‑N noch stabiler und schneller wird." },
      { title: "Bleib auf dem Laufenden", body: "Folge unseren offiziellen Kanälen oder schaue später erneut vorbei." },
      { title: "Neuerungen", body: "Hier kannst du demnächst lesen, was sich ändert und welche Vorteile das bringt." },
      { title: "Support", body: "Bei Fragen erreichst du uns über die bekannten Kanäle." },
    ],
    extendedCountdownBehavior: 'none',
    extendedCountdownText: 'Jetzt gleich sofort...',
    until: "",
    whitelistPaths: "",
  });

  useEffect(() => {
    let active = true;
    (async () => {
      try {
        const s = await MaintenanceAPI.getSettings();
        if (!active) return;
        setForm({
          enabled: !!s.enabled,
          message: s.message || "",
          allowLogin: s.allowLogin !== false,
          allowImpressumPublic: s.allowImpressumPublic !== false,
          extendedMode: !!s.extendedMode,
          extendedCountdownBehavior: s.extendedCountdownBehavior || 'none',
          extendedCountdownText: s.extendedCountdownText || 'Jetzt gleich sofort...',
          extendedContent: Array.isArray(s.extendedContent) && s.extendedContent.length
            ? s.extendedContent.slice(0,4).map(t => ({ title: t?.title || "", body: t?.body || "" }))
            : [
                { title: "Was passiert gerade?", body: "Wir führen Wartungsarbeiten durch, damit AP‑N noch stabiler und schneller wird." },
                { title: "Bleib auf dem Laufenden", body: "Folge unseren offiziellen Kanälen oder schaue später erneut vorbei." },
                { title: "Neuerungen", body: "Hier kannst du demnächst lesen, was sich ändert und welche Vorteile das bringt." },
                { title: "Support", body: "Bei Fragen erreichst du uns über die bekannten Kanäle." },
              ],
          until: s.until ? new Date(s.until).toISOString().slice(0,16) : "",
          whitelistPaths: Array.isArray(s.whitelistPaths) ? s.whitelistPaths.join("\n") : "",
        });
      } catch (e) {
        setError(e?.response?.data?.error || e?.message || "Fehler beim Laden der Einstellungen.");
      } finally {
        setLoading(false);
      }
    })();
    return () => { active = false; };
  }, []);

  async function save() {
    setSaving(true); setError(""); setMsg("");
    try {
      const payload = {
        enabled: !!form.enabled,
        message: form.message || "",
        allowLogin: !!form.allowLogin,
        // Admins/Owner sollen immer zugreifen können
        allowAdmins: true,
        allowImpressumPublic: !!form.allowImpressumPublic,
        extendedMode: !!form.extendedMode,
        extendedContent: (Array.isArray(form.extendedContent) ? form.extendedContent : []).slice(0,4).map(t => ({
          title: (t?.title || "").slice(0, 200),
          body: (t?.body || "").slice(0, 2000),
        })),
        extendedCountdownBehavior: form.extendedCountdownBehavior,
        extendedCountdownText: (form.extendedCountdownText || 'Jetzt gleich sofort...').slice(0, 400),
        until: form.until ? new Date(form.until) : null,
        whitelistPaths: (form.whitelistPaths || "").split(/\r?\n/).map(s => s.trim()).filter(Boolean),
      };
      await MaintenanceAPI.saveSettings(payload);
      setMsg("Gespeichert.");
    } catch (e) {
      setError(e?.response?.data?.error || e?.message || "Speichern fehlgeschlagen.");
    } finally {
      setSaving(false);
    }
  }

  if (loading) return <div style={{padding:24}}>Einstellungen werden geladen …</div>;

  return (
    <div className="home-page">
      {/* Hero Header */}
      <section style={{ width:'100vw', margin:0, padding:0, position:'relative', left:'-120px' }}>
        <h1 className="hero-title" style={{ textAlign:'center', margin:'0 0 8px' }}>Wartungsmodus</h1>
        <p className="hero-desc" style={{ margin:'0 auto 24px', textAlign:'center', maxWidth:760 }}>Aktiviere den Wartungsmodus, sperre reguläre Zugriffe und definiere Ausnahmen.</p>
      </section>

      {/* Centered content */}
      <section style={{ width:'100%', maxWidth: 800, margin:'0 auto', padding:'0 16px 40px 16px', color:'#fff' }}>
        {error && (
          <div style={{color:'tomato', marginBottom:12, border:'1px solid rgba(255,99,71,0.4)', background:'rgba(255,99,71,0.08)', padding:'8px 12px', borderRadius:8}}>
            {error}
          </div>
        )}
        {msg && (
          <div style={{color:'#32CD89', marginBottom:12, border:'1px solid rgba(50,205,137,0.4)', background:'rgba(50,205,137,0.08)', padding:'8px 12px', borderRadius:8}}>
            {msg}
          </div>
        )}

        {/* Settings Card */}
        <div style={{ border:'1px solid rgba(255,255,255,0.15)', borderRadius:8, padding:16, marginBottom:16, background:'rgba(255,255,255,0.03)' }}>
          <div style={{display:'flex', alignItems:'center', gap:10, marginBottom:12}}>
            <label style={{display:'flex', alignItems:'center', gap:10}}>
              <input type="checkbox" checked={!!form.enabled} onChange={e => setForm(f => ({...f, enabled: e.target.checked}))} />
              <b>Wartungsmodus aktiv</b>
            </label>
            {form.enabled && (
              <span style={{marginLeft:'auto', fontSize:13, color:'#FFD700'}}>Aktiv – öffentliche Zugriffe sind eingeschränkt</span>
            )}
          </div>

          <div style={{ marginBottom:12 }}>
            <div style={{fontWeight:700, marginBottom:6}}>Öffentliche Nachricht</div>
            <textarea
              value={form.message}
              onChange={e => setForm(f => ({...f, message: e.target.value}))}
              rows={4}
              className="hero-btn-secondary"
              style={{ width:'100%', minHeight:110 }}
              placeholder="Wir führen gerade Wartungsarbeiten durch. Bitte versuche es später erneut."
            />
          </div>

          <div style={{display:'flex', gap:16, flexWrap:'wrap', marginBottom:12}}>
            <label style={{display:'flex', alignItems:'center', gap:10}}>
              <input type="checkbox" checked={!!form.extendedMode} onChange={e => setForm(f => ({...f, extendedMode: e.target.checked}))} />
              Erweiterter Wartungsmodus (Startseite zeigt erweitert Inhalte)
            </label>
            <span style={{opacity:.8, fontSize:12}}>Bei aktiviertem erweiterten Modus erscheint eine erweiterte Wartungsseite.</span>
          </div>

          <div style={{display:'flex', gap:16, flexWrap:'wrap', marginBottom:12}}>
            <label style={{display:'flex', alignItems:'center', gap:10}}>
              <input type="checkbox" checked={!!form.allowLogin} onChange={e => setForm(f => ({...f, allowLogin: e.target.checked}))} />
              Login für alle erlauben
            </label>
            <span style={{opacity:.85, fontSize:13}}>(Administratoren/Owner können sich immer anmelden.)</span>
          </div>

          <div style={{display:'flex', gap:16, flexWrap:'wrap', marginBottom:12}}>
            <label style={{display:'flex', alignItems:'center', gap:10}}>
              <input type="checkbox" checked={!!form.allowImpressumPublic} onChange={e => setForm(f => ({...f, allowImpressumPublic: e.target.checked}))} />
              Impressumsseiten während Wartung öffentlich anzeigen
            </label>
            <span style={{opacity:.8, fontSize:12}}>Gilt für Pfade wie /impressum/page/:userId und /impressum/public/:userId.</span>
          </div>

          <div style={{ marginBottom:12 }}>
            <div style={{fontWeight:700, marginBottom:6}}>Geplant bis (optional)</div>
            <input
              type="datetime-local"
              value={form.until}
              onChange={e => setForm(f => ({...f, until: e.target.value}))}
              className="hero-btn-secondary"
              style={{ padding:'10px 12px' }}
            />
          </div>

          <div>
            <div style={{fontWeight:700, marginBottom:6}}>Whitelist-Pfade (ein Präfix pro Zeile)</div>
            <textarea
              value={form.whitelistPaths}
              onChange={e => setForm(f => ({...f, whitelistPaths: e.target.value}))}
              rows={4}
              className="hero-btn-secondary"
              style={{ width:'100%', minHeight:110 }}
              placeholder="/impressum\n/api/events\n/uploads"
            />
            <div style={{fontSize:12, opacity:.8, marginTop:6}}>Diese Pfad‑Präfixe bleiben trotz Wartungsmodus erreichbar.</div>
          </div>
        </div>

        {/* Extended content editor */}
        <div style={{ border:'1px solid rgba(255,255,255,0.15)', borderRadius:8, padding:16, marginBottom:16, background:'rgba(255,255,255,0.03)' }}>
          <div style={{display:'flex', alignItems:'center', justifyContent:'space-between', gap:10, marginBottom:12}}>
            <div style={{fontWeight:800}}>Erweiterte Startseiten-Kacheln (max. 4)</div>
            <div style={{fontSize:12, opacity:.7}}>Sichtbar bei aktiviertem erweiterten Wartungsmodus</div>
          </div>
          <div style={{
            display:'grid',
            gridTemplateColumns:'repeat(auto-fit, minmax(260px, 1fr))',
            gap:16
          }}>
            {form.extendedContent.map((tile, idx) => (
              <div key={idx} style={{ border:'1px solid rgba(255,255,255,0.12)', borderRadius:10, padding:12, background:'rgba(255,255,255,0.02)' }}>
                <div style={{fontWeight:700, fontSize:13, marginBottom:8}}>Kachel {idx+1}</div>
                <input
                  className="hero-btn-secondary"
                  style={{ width:'100%', padding:'10px 12px', marginBottom:8 }}
                  placeholder="Titel"
                  value={tile.title}
                  onChange={e => setForm(f => {
                    const cc = [...f.extendedContent]; cc[idx] = { ...cc[idx], title: e.target.value }; return { ...f, extendedContent: cc };
                  })}
                  maxLength={200}
                />
                <textarea
                  className="hero-btn-secondary"
                  style={{ width:'100%', minHeight:96, padding:'10px 12px' }}
                  placeholder="Beschreibung"
                  value={tile.body}
                  onChange={e => setForm(f => {
                    const cc = [...f.extendedContent]; cc[idx] = { ...cc[idx], body: e.target.value }; return { ...f, extendedContent: cc };
                  })}
                  rows={4}
                  maxLength={2000}
                />
              </div>
            ))}
          </div>
        </div>

        {/* Countdown-Verhalten */}
        <div style={{ border:'1px solid rgba(255,255,255,0.15)', borderRadius:8, padding:16, marginBottom:16, background:'rgba(255,255,255,0.03)' }}>
          <div style={{display:'flex', alignItems:'center', justifyContent:'space-between', gap:10, marginBottom:12}}>
            <div style={{fontWeight:800}}>Countdown – Verhalten bei 00:00:00</div>
            <div style={{fontSize:12, opacity:.7}}>Gilt im erweiterten Wartungsmodus</div>
          </div>
          <div style={{ display:'grid', gridTemplateColumns:'minmax(220px, 320px) 1fr', gap:12, alignItems:'center' }}>
            <select className="hero-btn-secondary" style={{ padding:'10px 12px' }}
              value={form.extendedCountdownBehavior}
              onChange={e => setForm(f => ({ ...f, extendedCountdownBehavior: e.target.value }))}
            >
              <option value="none">Nix (Counter bleibt bei 0)</option>
              <option value="autoExtend">Neu (alle 6h automatisch verlängern)</option>
              <option value="text">Text (statt Countdown Text anzeigen)</option>
              <option value="off">Aus (Wartungsmodus automatisch beenden)</option>
            </select>
            {form.extendedCountdownBehavior === 'text' && (
              <input
                className="hero-btn-secondary"
                style={{ padding:'10px 12px' }}
                placeholder="Text bei 0, z.B. Jetzt gleich sofort..."
                value={form.extendedCountdownText}
                onChange={e => setForm(f => ({ ...f, extendedCountdownText: e.target.value }))}
                maxLength={400}
              />
            )}
          </div>
        </div>

        <div>
          <button className="hero-btn-primary" onClick={save} disabled={saving}>
            {saving ? 'Speichert …' : 'Einstellungen speichern'}
          </button>
        </div>
      </section>
    </div>
  );
}
